export default __webpack_public_path__ + "static/media/underconst.21ac14ee.gif";